module.exports = __webpack_public_path__ + "static/img/xingspa_icon.bf69776.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img_icon/xingspa_icon.png
// module id = nktu
// module chunks = 1